// extracted by mini-css-extract-plugin
module.exports = {"textarea":"ItemText_textarea_3Pswp","textareaStroke":"ItemText_textareaStroke_2tD31","svg":"ItemText_svg_R3aG8"};